<div class="container-fluid">
    <mat-accordion multi>
        @for (location of locations; track location){
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{location.display_name}}
                </mat-panel-title>
                <mat-panel-description>
                    {{location.address.line1}}, {{location.address.city}} {{location.address.state}},
                    {{location.address.postal_code}}
                </mat-panel-description>
            </mat-expansion-panel-header>
            <hr />
            <div id="body">
                @for(reader of readers; track reader){
                @if(reader.location === location.id){
                <div class="row align-items-center">
                    <div class="col-3">
                        <p>Name: <strong>{{reader.label}}</strong></p>
                    </div>
                    <div class="col-2">
                        <p>Status: <strong
                                [ngClass]="reader.status === 'online' ? 'online' : 'offline'">{{reader.status}}</strong>
                        </p>
                    </div>
                    <div class="col-3">
                        <p>Serial Number: <strong>{{reader.serial_number}}</strong></p>
                    </div>
                    <div class="col-2">
                        <button mat-stroked-button class="secondary" (click)="refreshReader(reader)">Refresh</button> &nbsp;
                        <button mat-stroked-button class="warning" (click)="deleteReader(reader)">Delete</button>
                    </div>
                    <div class="col-2" *ngIf="reader.isRefreshing">
                        <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
                    </div>
                </div>
                }
                }
                <div class="row mt-3">
                    <div class="col">
                        <button mat-raised-button (click)="createReader(location)">Pair Reader</button>&nbsp;
                        <button mat-raised-button class="warning" (click)="deleteLocation(location)">Delete Location</button>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        }
    </mat-accordion>
</div>